<script lang="ts">
    import {
    responsivetablebody,
  } from "../../../../Data/Table/SveltestrapTable/SveltestrapTable";
</script>

{#each responsivetablebody as tableItem}
  <tr>
    <th scope="row">{tableItem.num}</th>
    <td>{tableItem.header}</td>
    <td>{tableItem.header2}</td>
    <td>{tableItem.header3}</td>
    <td>{tableItem.header4}</td>
    <td>{tableItem.header5}</td>
    <td>{tableItem.header6}</td>
    <td>{tableItem.header7}</td>
    <td>{tableItem.header8}</td>
    <td>{tableItem.header9}</td>
    <td>{tableItem.header10}</td>
    <td>{tableItem.header11}</td>
    <td>{tableItem.header12}</td>
    <td>{tableItem.header13}</td>
    <td>{tableItem.header14}</td>
  </tr>
{/each}
